
























import { Component, Prop, Vue } from 'vue-property-decorator';

export default Vue.extend({
  name: 'PagePicker',
  props: {
    numPages: { type: Number },
    currentPage: { type: Number },
    lastPage: { type: Number },
  },
  data: () => ({
    quickPageRange: [1, 2],
  }),
  methods: {
    changePage(nextPage) {
      if (nextPage < 1 || nextPage > this.lastPage) {
        return;
      }
      this.$emit('change-page', nextPage);
    },
    calculateQuickPageRange() {
      const start = this.currentPage === 1 ? 1 : Math.max(2, this.currentPage - 2);
      const end = Math.min(this.lastPage, this.currentPage + 2);

      this.quickPageRange = [];
      for (let i = start; i <= end; i += 1) {
        this.quickPageRange.push(i);
      }
    },
  },
  watch: {
    currentPage: 'calculateQuickPageRange',
    lastPage: 'calculateQuickPageRange',
  },
  mounted() {
    this.calculateQuickPageRange();
  },
  computed: {
  },
});
